import React from 'react';

interface Props {
  what?: string;
}

export const SystemTenantNotice: React.FC<Props> = ({ what }) => (
  <div className="rounded bg-purple-50 border border-purple-200 px-3 py-2 text-sm text-purple-900 mb-4">
    Tenant système — {what || 'cette configuration est en lecture seule'}. Seuls
    l'identité (nom) et le storage sont modifiables (cf. doc <code>MULTITENANT_MODEL.md</code> § Tenant système).
  </div>
);

export default SystemTenantNotice;
